export { default } from './sale-promo-banner'
